//温度相关的属性对照
export const props_T: any = {
  "Liquid_Thermal_Conductivity": {
    name: "液相导热率",
    unit: "W/mK",
  },
  "Gas_Thermal_Conductivity": {
    name: "气相导热率",
    unit: "W/mK",
  },
  "Ideal_Gas_Heat_Capacity": {
    name: "理想气体 Cp",
    unit: "J/mol*K",
  },
  "Solid_Heat_Capacity": {
    name: "固体 Cp",
    unit: "J/mol*K",
  },
  "Heat_of_Vaporization": {
    name: "蒸发焓",
    unit: "J/mol",
  },
  "Molar_Liquid_Density": {
    name: "液相摩尔密度",
    unit: "mol/m³",
  },
  "Molar_Solid_Density": {
    name: "固相摩尔密度",
    unit: "mol/m³",
  },
  "Liquid_Viscosity": {
    name: "液体黏度",
    unit: "Pa*s",
  },
  "Gas_Viscosity": {
    name: "气体黏度",
    unit: "Pa*s",
  },
  "Saturation_Vapor_Pressure_Gas_Liquid": {
    name: "气‑液饱和压",
    unit: "Pa",
  },
  "Saturation_Vapor_Pressure_Gas_Solid": {
    name: "气‑固饱和压",
    unit: "Pa",
  },
  "Surface_Tension": {
    name: "表面张力",
    unit: "N/m",
  },
  "Solubility_in_Water": {
    name: "水中溶解度",
    unit: "",
  }
}

